export const CATEGORIES = ['All', 'Documents', 'PDF Editor', 'Images', 'Data', 'Presentations'];

export const CONVERSIONS = [
  {
    id: 'pdf-word',
    slug: 'pdf-to-word',
    from: 'PDF',
    to: 'DOCX',
    fromExt: '.pdf',
    toExt: '.docx',
    label: 'PDF to Word',
    desc: 'Editable Word document',
    category: 'Documents',
    options: ['Preserve formatting', 'Keep images', 'Extract tables', 'Use Aptos (Body)', 'OCR text'],
    accept: '.pdf',
  },
  {
    id: 'pdf-compress',
    slug: 'compress-pdf',
    from: 'PDF',
    to: 'PDF',
    fromExt: '.pdf',
    toExt: '.pdf',
    label: 'Compress PDF',
    desc: 'Reduce file size by compressing content and images',
    category: 'PDF Editor',
    options: ['Compress content'],
    accept: '.pdf',
  },
  {
    id: 'pdf-rotate',
    slug: 'rotate-pdf',
    from: 'PDF',
    to: 'PDF',
    fromExt: '.pdf',
    toExt: '.pdf',
    label: 'Rotate PDF',
    desc: 'Rotate all pages 90° clockwise',
    category: 'PDF Editor',
    options: [],
    accept: '.pdf',
  },
  {
    id: 'pdf-edit',
    slug: 'edit-pdf',
    from: 'PDF',
    to: 'PDF',
    fromExt: '.pdf',
    toExt: '.pdf',
    label: 'PDF Editor',
    desc: 'Edit text, highlight and annotate PDF pages',
    category: 'PDF Editor',
    options: [],
    accept: '.pdf',
  },
  {
    id: 'pdf-merge',
    slug: 'merge-pdf',
    from: 'PDF',
    to: 'PDF',
    fromExt: '.pdf',
    toExt: '.pdf',
    label: 'Merge PDF',
    desc: 'Combine multiple PDF files into one',
    category: 'PDF Editor',
    options: ['Maintain bookmarks', 'Add table of contents'],
    accept: '.pdf',
  },
  {
    id: 'pdf-split',
    slug: 'split-pdf',
    from: 'PDF',
    to: 'ZIP',
    fromExt: '.pdf',
    toExt: '.zip',
    label: 'Split PDF',
    desc: 'Extract pages as separate PDF files',
    category: 'PDF Editor',
    options: ['Split by range', 'All pages'],
    accept: '.pdf',
  },
  {
    id: 'pdf-remove',
    slug: 'remove-pdf-pages',
    from: 'PDF',
    to: 'PDF',
    fromExt: '.pdf',
    toExt: '.pdf',
    label: 'Remove PDF Pages',
    desc: 'Delete unwanted pages from your PDF file',
    category: 'PDF Editor',
    options: [],
    accept: '.pdf',
  },
  {
    id: 'pdf-unlock',
    slug: 'unlock-pdf',
    from: 'PDF',
    to: 'PDF',
    fromExt: '.pdf',
    toExt: '.pdf',
    label: 'Unlock PDF',
    desc: 'Remove password and restrictions from PDF',
    category: 'PDF Editor',
    options: [],
    accept: '.pdf',
  },
  {
    id: 'pdf-protect',
    slug: 'protect-pdf',
    from: 'PDF',
    to: 'PDF',
    fromExt: '.pdf',
    toExt: '.pdf',
    label: 'Protect PDF',
    desc: 'Add password and encrypt your PDF',
    category: 'PDF Editor',
    options: ['Restrict printing', 'Restrict editing'],
    accept: '.pdf',
  },
  {
    id: 'pdf-organize',
    slug: 'organize-pdf',
    from: 'PDF',
    to: 'PDF',
    fromExt: '.pdf',
    toExt: '.pdf',
    label: 'Organize PDF',
    desc: 'Reorder, delete, or add pages to your PDF file',
    category: 'PDF Editor',
    options: [],
    accept: '.pdf',
  },
  {
    id: 'word-pdf',
    slug: 'word-to-pdf',
    from: 'DOCX',
    to: 'PDF',
    fromExt: '.docx',
    toExt: '.pdf',
    label: 'Word to PDF',
    desc: 'Universal PDF output',
    category: 'Documents',
    options: ['High quality', 'Compress output', 'Include bookmarks', 'Embed fonts'],
    accept: '.docx,.doc',
  },
  {
    id: 'img-pdf',
    slug: 'image-to-pdf',
    from: 'JPG/PNG',
    to: 'PDF',
    fromExt: '.jpg/.png',
    toExt: '.pdf',
    label: 'Image to PDF',
    desc: 'Combine images into PDF',
    category: 'Images',
    options: ['Auto-rotate', 'A4 page size', 'Fit to page', 'Add margins'],
    accept: '.jpg,.jpeg,.png,.webp,.gif',
  },
  {
    id: 'pdf-img',
    slug: 'pdf-to-image',
    from: 'PDF',
    to: 'ZIP',
    fromExt: '.pdf',
    toExt: '.zip',
    label: 'PDF to Images',
    desc: 'Extract all pages as PNG images in a ZIP',
    category: 'Images',
    options: ['300 DPI', 'Transparent bg'],
    accept: '.pdf',
  },
  {
    id: 'jpg-png',
    slug: 'jpg-to-png',
    from: 'JPG',
    to: 'PNG',
    fromExt: '.jpg',
    toExt: '.png',
    label: 'JPG to PNG',
    desc: 'Lossless image conversion',
    category: 'Images',
    options: ['Lossless', 'Preserve metadata', 'Max quality'],
    accept: '.jpg,.jpeg',
  },
  {
    id: 'png-jpg',
    slug: 'png-to-jpg',
    from: 'PNG',
    to: 'JPG',
    fromExt: '.png',
    toExt: '.jpg',
    label: 'PNG to JPG',
    desc: 'Compress for web sharing',
    category: 'Images',
    options: ['Quality 90%', 'Strip metadata', 'Optimize size'],
    accept: '.png',
  },
  {
    id: 'avif-png',
    slug: 'avif-to-png',
    from: 'AVIF',
    to: 'PNG',
    fromExt: '.avif',
    toExt: '.png',
    label: 'AVIF to PNG',
    desc: 'Lossless AVIF conversion',
    category: 'Images',
    options: ['Lossless', 'Preserve transparency'],
    accept: '.avif',
  },
  {
    id: 'avif-jpg',
    slug: 'avif-to-jpg',
    from: 'AVIF',
    to: 'JPG',
    fromExt: '.avif',
    toExt: '.jpg',
    label: 'AVIF to JPG',
    desc: 'AVIF to universal JPEG',
    category: 'Images',
    options: ['Quality 90%', 'Optimize size'],
    accept: '.avif',
  },
  {
    id: 'png-avif',
    slug: 'png-to-avif',
    from: 'PNG',
    to: 'AVIF',
    fromExt: '.png',
    toExt: '.avif',
    label: 'PNG to AVIF',
    desc: 'Next-gen AVIF compression',
    category: 'Images',
    options: ['Max compression', 'Preserve alpha'],
    accept: '.png',
  },
  {
    id: 'jpg-avif',
    slug: 'jpg-to-avif',
    from: 'JPG',
    to: 'AVIF',
    fromExt: '.jpg',
    toExt: '.avif',
    label: 'JPG to AVIF',
    desc: 'Convert to modern AVIF',
    category: 'Images',
    options: ['Optimize size', 'Quality 85%'],
    accept: '.jpg,.jpeg',
  },
  {
    id: 'webp-png',
    slug: 'webp-to-png',
    from: 'WEBP',
    to: 'PNG',
    fromExt: '.webp',
    toExt: '.png',
    label: 'WEBP to PNG',
    desc: 'WebP to lossless PNG',
    category: 'Images',
    options: ['Lossless', 'Preserve transparency'],
    accept: '.webp',
  },
  {
    id: 'webp-jpg',
    slug: 'webp-to-jpg',
    from: 'WEBP',
    to: 'JPG',
    fromExt: '.webp',
    toExt: '.jpg',
    label: 'WEBP to JPG',
    desc: 'WebP to universal JPEG',
    category: 'Images',
    options: ['Quality 90%', 'Optimize size'],
    accept: '.webp',
  },
  {
    id: 'png-webp',
    slug: 'png-to-webp',
    from: 'PNG',
    to: 'WEBP',
    fromExt: '.png',
    toExt: '.webp',
    label: 'PNG to WEBP',
    desc: 'Web-optimized WebP',
    category: 'Images',
    options: ['Lossless WEBP', 'Optimize size'],
    accept: '.png',
  },
  {
    id: 'jpg-webp',
    slug: 'jpg-to-webp',
    from: 'JPG',
    to: 'WEBP',
    fromExt: '.jpg',
    toExt: '.webp',
    label: 'JPG to WEBP',
    desc: 'Convert to efficient WebP',
    category: 'Images',
    options: ['Optimize size', 'Quality 85%'],
    accept: '.jpg,.jpeg',
  },
  {
    id: 'svg-png',
    slug: 'svg-to-png',
    from: 'SVG',
    to: 'PNG',
    fromExt: '.svg',
    toExt: '.png',
    label: 'SVG to PNG',
    desc: 'Vector to high-res PNG',
    category: 'Images',
    options: ['Transparent bg', 'High DPI scaling'],
    accept: '.svg',
  },
  {
    id: 'svg-jpg',
    slug: 'svg-to-jpg',
    from: 'SVG',
    to: 'JPG',
    fromExt: '.svg',
    toExt: '.jpg',
    label: 'SVG to JPG',
    desc: 'Vector to universal JPEG',
    category: 'Images',
    options: ['White background', 'Quality 90%'],
    accept: '.svg',
  },
  {
    id: 'png-svg',
    slug: 'png-to-svg',
    from: 'PNG',
    to: 'SVG',
    fromExt: '.png',
    toExt: '.svg',
    label: 'PNG to SVG',
    desc: 'Embed PNG inside SVG',
    category: 'Images',
    options: ['Base64 encoding', 'Preserve dimensions'],
    accept: '.png',
  },
  {
    id: 'jpg-svg',
    slug: 'jpg-to-svg',
    from: 'JPG',
    to: 'SVG',
    fromExt: '.jpg',
    toExt: '.svg',
    label: 'JPG to SVG',
    desc: 'Embed JPG inside SVG',
    category: 'Images',
    options: ['Base64 encoding', 'Preserve dimensions'],
    accept: '.jpg,.jpeg',
  },
  {
    id: 'excel-pdf',
    slug: 'excel-to-pdf',
    from: 'XLSX',
    to: 'PDF',
    fromExt: '.xlsx',
    toExt: '.pdf',
    label: 'Excel to PDF',
    desc: 'Spreadsheet to PDF',
    category: 'Data',
    options: ['Landscape', 'Fit to width', 'All sheets', 'Show gridlines'],
    accept: '.xlsx,.xls',
  },
  {
    id: 'csv-excel',
    slug: 'csv-to-excel',
    from: 'CSV',
    to: 'XLSX',
    fromExt: '.csv',
    toExt: '.xlsx',
    label: 'CSV to Excel',
    desc: 'Data to spreadsheet',
    category: 'Data',
    options: ['Auto-detect types', 'Add filters', 'Style headers', 'Freeze rows'],
    accept: '.csv',
  },
  {
    id: 'excel-csv',
    slug: 'excel-to-csv',
    from: 'XLSX',
    to: 'CSV',
    fromExt: '.xlsx',
    toExt: '.csv',
    label: 'Excel to CSV',
    desc: 'Export spreadsheet data',
    category: 'Data',
    options: ['UTF-8 encoding', 'Include headers', 'First sheet only'],
    accept: '.xlsx,.xls',
  },
  {
    id: 'pptx-pdf',
    slug: 'powerpoint-to-pdf',
    from: 'PPTX',
    to: 'PDF',
    fromExt: '.pptx',
    toExt: '.pdf',
    label: 'PowerPoint to PDF',
    desc: 'Presentation to PDF',
    category: 'Presentations',
    options: ['Include notes', 'High quality', 'All slides', '16:9 layout'],
    accept: '.pptx,.ppt',
  },
  {
    id: 'md-word',
    slug: 'markdown-to-word',
    from: 'MD',
    to: 'DOCX',
    fromExt: '.md',
    toExt: '.docx',
    label: 'Markdown to Word',
    desc: 'Markdown to document',
    category: 'Documents',
    options: ['Apply heading styles', 'Include TOC', 'Preserve links', 'Code blocks'],
    accept: '.md,.markdown',
  },
  {
    id: 'html-pdf',
    slug: 'html-to-pdf',
    from: 'HTML',
    to: 'PDF',
    fromExt: '.html',
    toExt: '.pdf',
    label: 'HTML to PDF',
    desc: 'Web page to PDF',
    category: 'Documents',
    options: [
      'Full page',
      'Print styles',
      'A4 format',
      'Background colors',
      'Tables as text',
      'Remove borders',
    ],
    accept: '.html,.htm',
  },
  {
    id: 'pdf-pptx',
    slug: 'pdf-to-powerpoint',
    from: 'PDF',
    to: 'PPTX',
    fromExt: '.pdf',
    toExt: '.pptx',
    label: 'PDF to PowerPoint',
    desc: 'Convert PDF to PPTX slides',
    category: 'Presentations',
    options: ['One page per slide', 'Preserve layout', 'High quality'],
    accept: '.pdf',
  },
  {
    id: 'pdf-sign',
    slug: 'sign-pdf',
    from: 'PDF',
    to: 'PDF',
    fromExt: '.pdf',
    toExt: '.pdf',
    label: 'Sign PDF',
    desc: 'Add your signature to any PDF page',
    category: 'PDF Editor',
    options: [],
    accept: '.pdf',
  },
];

export const STEPS = [
  'Reading file...',
  'Parsing structure...',
  'Processing content...',
  'Converting format...',
  'Optimizing output...',
  'Finalizing...',
  'Almost Done!',
];
